import { apiClient, type ApiResponse } from './client'
import type { Member } from './b2b'
import type { DiagnosticAssignmentRow } from './adminDiagnostics'
import type { LearnerStatusCode } from './learnerStatus'

/** 진단 응시 불가 사유. 판정은 서버(학년도 3월 1일 경계, KST)가 내린다. */
export type DiagnosticIneligibleReason = 'PRESCHOOL' | 'BIRTH_DATE_MISSING'

export interface LcStudentDiagnostic {
  rows: DiagnosticAssignmentRow[]
  hasCompletedReport: boolean
  /** false면 진단 메뉴·회차 전체 숨김(rows는 빈 배열) */
  eligible: boolean
  ineligibleReason: DiagnosticIneligibleReason | null
}

export interface LcStudentRow {
  member: Member
  derivedStatus: LearnerStatusCode
  courseName: string | null
  classNames: string[] | null
  diagnostic: LcStudentDiagnostic | null
}

export interface LcStudentPageResponse {
  content: LcStudentRow[]
  page: number
  size: number
  totalElements: number
  totalPages: number
  totalsByStatus: Record<LearnerStatusCode, number>
}

export interface LcStudentSearchParams {
  q?: string
  status?: LearnerStatusCode
  sort?: 'name' | 'gradeLevel' | 'createdAt'
  dir?: 'asc' | 'desc'
  page?: number
  size?: number
}

export const lcStudentApi = {
  search: (params: LcStudentSearchParams) =>
    apiClient.get<ApiResponse<LcStudentPageResponse>>('/lc/admin/students', {
      params: {
        q: params.q && params.q.length > 0 ? params.q : undefined,
        status: params.status || undefined,
        sort: params.sort || 'createdAt',
        dir: params.dir || 'desc',
        page: params.page ?? 0,
        size: params.size ?? 20,
      },
    }),
}
